/*
    Accordions
*/
function initAccordions() {
	// Find and iterate through all of the uninitialized accordions
	let didInitialize = false;
	let pageAccordions = document.querySelectorAll('.js-accordion-button:not([data-init="true"])');
	if (pageAccordions !== null && pageAccordions.length) {
		didInitialize = true;
		pageAccordions.forEach(function (accordion, index) {
			// See if it has a valid cotnent section
			let accordionContent = accordion.parentNode.querySelector(".js-accordion-content");
			if (accordionContent !== null) {
				// Set up the properties
				accordion.setAttribute("aria-expanded", false);
				let ran = Math.floor(Math.random() * 10000000000000);
				accordion.setAttribute("aria-controls", "ac_" + ran);
				accordion.setAttribute("id", "ach_" + ran);
				accordionContent.setAttribute("id", "ac_" + ran);
				accordionContent.setAttribute("aria-labeledby", "ach_" + ran);

				// Attach the click events
				accordion.addEventListener("click", function (event) {
					const mobileNavParent = getParentElementWithClass(this, "site-nav");
					if (mobileNavParent) {
						mobileNavParent.parentNode.classList.toggle("menu-open");
					}
					if (!event.target.classList.contains("arrow-lnk")) {
						this.parentNode.classList.toggle("active");
						vSlideToggle(accordionContent);
					}

					if (this.getAttribute("aria-expanded") == "true") {
						this.setAttribute("aria-expanded", "false");
					} else {
						this.setAttribute("aria-expanded", "true");
					}
				});
				let accordionClose = accordion.parentElement.querySelector(".js-accordion-close");
				if (accordionClose) {
					accordionClose.addEventListener("click", function (event) {
						accordion.parentElement.classList.remove("active");
						vSlideUp(accordionContent);
						accordion.setAttribute("aria-expanded", "false");
					});
				}

				// Hide all accordion content on page load
				if (accordion.parentElement.classList.contains("js-mobile-only")) {
					if (window.innerWidth < TABLETBREAK) {
						accordionContent.style.display = "none";
					}
					window.addEventListener("resize", function () {
						if (
							window.innerWidth >= TABLETBREAK &&
							accordion.parentElement.classList.contains("js-mobile-only") &&
							(accordionContent.style.display == "none" ||
								getComputedStyle(accordionContent).display == "none")
						) {
							accordionContent.style.display = "block";
						} else if (
							window.innerWidth < TABLETBREAK &&
							accordion.parentElement.classList.contains("js-mobile-only") &&
							!accordion.parentElement.classList.contains("active") &&
							(accordionContent.style.display == "block" ||
								getComputedStyle(accordionContent).display == "block")
						) {
							accordionContent.style.display = "none";
						}
					});
				} else {
					accordionContent.style.display = "none";
				}

				// Set a property of the accordion so we can tell it was initialized. Accordions without this property will be initialized by initAccordions();
				accordion.setAttribute("data-init", true);
			}
		});
	}
	return didInitialize;
}
// Accordion Script -- fire if accordions exist
initAccordions();


/*
    Tabs

	<div class="tabs-area js-tabs-area">
		<article class="tab js-tab" aria-label="Tab Title">
			<button class="js-tab-header tab-header">Tab Title</button>
			<div class="tab-content js-tab-content">
				<!-- content -->
			</div>
		</article>
	</div>
*/
function initTabs() {
	// Find and iterate through all of the uninitialized accordions
	let didInitialize = false;
	let pageTabAreas = document.querySelectorAll(".js-tabs-area:not([data-tab-init])");
	if (pageTabAreas !== null && pageTabAreas.length) {
		didInitialize = true;
		for (i = 0; i < pageTabAreas.length; i++) {
			// Set up the properties
			let area = pageTabAreas[i];
			let header = "";

			// Go through each set of tabs
			let tabs = area.querySelectorAll(".js-tab");
			if (tabs !== null && tabs.length) {
				for (j = 0; j < tabs.length; j++) {
					// Combine tab headers to display as header
					let theTabHeader = tabs[j].querySelector(".js-tab-header");
					let theTabContent = tabs[j].querySelector(".js-tab-content");
					if(theTabHeader && theTabContent) {

					}

					// Add the control data to the tab button in the tab header
					if(theTabHeader) {
						theTabHeader.setAttribute("data-tab", j);
						theTabHeader.setAttribute("role", "tab");
					}

					// Add the control data to the tab content div
					if(theTabContent) {
						theTabContent.setAttribute("data-tab", j);
						theTabContent.setAttribute("role", "tabpanel");
					}

					// Remove the tab header we just processed.
					if(theTabHeader) {
						theTabHeader.remove();
					}

					if (j == 0) {
						if(theTabHeader) {
							theTabHeader.setAttribute("aria-selected", "true");
							theTabHeader.classList.add("tab-current");
						}
						if(theTabContent) {
							theTabContent.setAttribute("aria-selected", "true");
							theTabContent.classList.add("tab-current");
						}
					} else {
						if(theTabHeader) {
							theTabHeader.setAttribute("aria-selected", "false");
						}
						if(theTabContent) {
							theTabContent.setAttribute("aria-selected", "false");
						}
					}

					if(theTabHeader) {
						header += theTabHeader.outerHTML;
					}
				}
			}

			//Build header
			if(tabs.length > 1) {
				let tabHeaderAppend = document.createElement("div");
				tabHeaderAppend.classList.add("js-tab-nav");
				tabHeaderAppend.classList.add("tab-nav");
				tabHeaderAppend.setAttribute("role", "tablist");
				tabHeaderAppend.innerHTML = header;
				area.prepend(tabHeaderAppend);
			}

			// Click Events for Tabs
			let navTabs = area.querySelectorAll(".js-tab-nav .js-tab-header");
			if (navTabs !== null && navTabs.length) {
				for (k = 0; k < navTabs.length; k++) {
					navTabs[k].addEventListener("click", function (event) {
						// Hide current tab info and change the info in the dom
						let currentTabHeader = area.querySelector(".js-tab-header.tab-current");
						currentTabHeader.setAttribute("aria-selected", "false");
						currentTabHeader.classList.remove("tab-current");
						let currentTabContent = area.querySelector(".js-tab-content.tab-current");
						currentTabContent.classList.remove("tab-current");
						currentTabContent.setAttribute("aria-hidden", "true");

						// Show all the current tab content and change the info in the dom
						let newIndex = event.target.getAttribute("data-tab");

						let clickedTabHeader = area.querySelector(".js-tab-header[data-tab='" + newIndex + "']");
						clickedTabHeader.classList.add("tab-current");
						clickedTabHeader.setAttribute("aria-selected", "true");
						let clickedTabContent = area.querySelector(".js-tab-content[data-tab='" + newIndex + "']");
						clickedTabContent.classList.add("tab-current");
						clickedTabContent.setAttribute("aria-hidden", "false");
					});
				}
			}

			// Set a property of the tabs so we can tell it was initialized. Tabs without this property will be initialized by initTabs();
			area.setAttribute("data-tab-init", "true");
		}
	}
	return didInitialize;
}
// Tabs Script -- fire if tabs exist
initTabs();


function moveSlideTrack(activeEl) {
	const slideEl = activeEl.parentNode.parentNode.querySelector(".js-slide-track > .js-slide");
	slideEl.style.left =
		activeEl.offsetLeft -
		getParentElementWithClass(activeEl, "js-tab-section").offsetLeft +
		activeEl.offsetWidth / 2 -
		slideEl.offsetWidth / 2 +
		"px";
	// if (window.innerWidth > 1100) {
	// 	slideEl.style.left = activeEl.offsetLeft - getParentElementWithClass(activeEl, "js-tab-section").offsetLeft + (activeEl.offsetWidth / 2) - slideEl.offsetWidth / 2 + "px";
	// 	// slideEl.style.width = activeEl.offsetWidth + "px";
	// } else {
	// 	slideEl.style.left = activeEl.offsetLeft + activeEl.offsetWidth / 2 - 38 + "px";
	// 	// slideEl.style.width = activeEl.offsetWidth + "px";
	// }
}

window.addEventListener(
	"resize",
	() => {
		let tabs = document.querySelectorAll(".js-tab-section");
		tabs.forEach((el) => {
			let currentTab = el.querySelector('.js-tab-button[aria-selected="true"]');
			moveSlideTrack(currentTab);
		});
	},
	true
);

function changeTabs(index, tabs, panels) {
	resetTabButtons(tabs);
	resetTabPanels(panels);
	tabs[Number(index)].setAttribute("aria-selected", "true");
	panels[Number(index)].setAttribute("data-tab-active", "true");
	setTimeout(() => {
		panels[Number(index)].classList.add("open");
		
	}, 100);
	
	moveSlideTrack(tabs[Number(index)]);
}
function resetTabButtons(tabs) {
	tabs.forEach(function (button) {
		button.setAttribute("aria-selected", "false");
	});
}
function resetTabPanels(panels) {
	panels.forEach(function (panel) {
		panel.setAttribute("data-tab-active", "false");
		panel.classList.remove("open");
	});
}
// Tabs Script -- fire if tabs exist
initTabs();

/*
    Force scroll to anchor on load
*/
window.onload = function (event) {
	if (window.location.hash != "" && document.getElementById(window.location.hash.substring(1)) != null) {
		window.setTimeout(function () {
			let top = document.getElementById(window.location.hash.substring(1));
			top.scrollIntoView({ behavior: "smooth" });
		}, 600);
	}
};

// /* Compare Tables */
// function initComparisonTables() {
// 	// Find and iterate through all of the uninitialized compare tables
// 	let didInitialize = false;
// 	let compareTables = document.querySelectorAll('.js-compare-table:not([data-init="true"])');
// 	if (compareTables !== null && compareTables.length) {
// 		didInitialize = true;
// 		compareTables.forEach(function (table, index) {
// 			// Identify container to append elements to
// 			let tableContainer = table.querySelector(".js-table-container");
// 			// Identify the container
// 			let tableControlsDots = table.querySelector(".table-controls-dots");
// 			// Identify number of columns
// 			let tableCols = table.querySelectorAll(".mod-compare-table table tr:first-child th").length;
// 			// Identify all of the rows we need to iterate through
// 			let tableRows = table.querySelectorAll(".mod-compare-table tr");
// 			// Product Titles
// 			let tableTitles = [];

// 			// The title field for the account name in the arrow controls
// 			let tableControlsTitle = table.querySelector(".js-account-title");

// 			// Previous Button
// 			let tableNextButton = table.querySelector(".js-prev-account");
// 			tableNextButton.addEventListener("click", function (e) {
// 				let theTable = getParentElementWithClass(event.target, "js-compare-table");
// 				tablePrev(theTable, parseInt(theTable.getAttribute("data-current-position")));
// 				mobileButtonDisplay(theTable.getAttribute("data-current-position"));
// 			});

// 			// Next Button
// 			let tablePrevButton = table.querySelector(".js-next-account");
// 			tablePrevButton.addEventListener("click", function (e) {
// 				let theTable = getParentElementWithClass(event.target, "js-compare-table");
// 				tableNext(theTable, parseInt(theTable.getAttribute("data-current-position")));
// 				mobileButtonDisplay(theTable.getAttribute("data-current-position"));
// 			});

// 			// Adding data attributes for the cells
// 			for (i = 1; i < tableCols; i++) {
// 				tableTitles.push(tableRows[0].querySelectorAll("th")[i].innerHTML);
// 				table
// 					.querySelectorAll(".mod-compare-table tr > *:nth-child(" + (i + 1) + ")")
// 					.forEach(function (cell, index) {
// 						cell.setAttribute("data-pos", i);
// 					});
// 				if (i == 1) {
// 					tableControlsTitle.innerHTML = tableTitles[i - 1];
// 				}
// 			}

// 			// Carousel Dots
// 			tableTitles.forEach(function (title, index) {
// 				let carouselDot = document.createElement("li");
// 				let activeDot = "";
// 				if (index == 0) {
// 					activeDot = " is-active";
// 				}
// 				carouselDot.innerHTML =
// 					'<button class="carousel-dot js-carousel-dot' +
// 					activeDot +
// 					'" type="button" data-pos="' +
// 					(index + 1) +
// 					'"><span class="visuallyhidden">View ' +
// 					title +
// 					" Features</span></button>";
// 				tableControlsDots.append(carouselDot);
// 				carouselDot.addEventListener("click", function (e) {
// 					tableSwitch(
// 						getParentElementWithClass(event.target, "js-compare-table"),
// 						parseInt(event.target.getAttribute("data-pos"))
// 					);
// 				});
// 			});

// 			// Set the first product as active
// 			let firstCells = table.querySelectorAll(".mod-compare-table tr > *:nth-child(2)");
// 			firstCells.forEach(function (cell, index) {
// 				cell.classList.add("active");
// 				tableControlsTitle.innerHTML = tableTitles[0];
// 			});

// 			table.setAttribute("data-init", "true");
// 			table.setAttribute("data-current-position", 1);
// 		});
// 	}
// 	return didInitialize;
// }
// // Initialize the tables
// initComparisonTables();
// // Click Events
// function tablePrev(tableElem, currentIndex) {
// 	let newIndex = currentIndex - 1;
// 	let tableCols = tableElem.querySelectorAll("table tr:first-child > *").length;
// 	if (newIndex == 0) {
// 		newIndex = tableCols - 1;
// 	}
// 	tableSwitch(tableElem, newIndex);
// }
// function tableNext(tableElem, currentIndex) {
// 	let newIndex = currentIndex + 1;
// 	let tableCols = tableElem.querySelectorAll("table tr:first-child > *").length;
// 	if (newIndex == tableCols) {
// 		newIndex = 1;
// 	}
// 	tableSwitch(tableElem, newIndex);
// }
// function tableSwitch(tableElem, posNumber) {
// 	let oldCells = tableElem.querySelectorAll("th, td");
// 	oldCells.forEach(function (cell, index) {
// 		cell.classList.remove("active");
// 	});
// 	let newCells = tableElem.querySelectorAll("tr > *:nth-child(" + (parseInt(posNumber) + 1) + ")");
// 	newCells.forEach(function (cell, index) {
// 		cell.classList.add("active");
// 	});
// 	let carouselDots = tableElem.querySelectorAll(".js-carousel-dot");
// 	carouselDots.forEach(function (dot, index) {
// 		dot.classList.remove("is-active");
// 	});
// 	carouselDots[posNumber - 1].classList.add("is-active");
// 	tableElem.setAttribute("data-current-position", posNumber);
// 	tableElem.querySelector(".js-account-title").innerHTML = tableElem.querySelector(
// 		"tr:first-child > *:nth-child(" + (parseInt(posNumber) + 1) + ")"
// 	).innerHTML;
// }

// And this is the click event listener for the jumps links to scroll them into view
document.addEventListener("click", function (event) {
	if (event.target.matches(".js-jump-lnk")) {
		var btn = document.querySelectorAll(
			"[data-jump-name='" + event.target.dataset.jumpLnk.replaceAll(" ", "_") + "']"
		);
		if (btn.length) {
			btn[0].scrollIntoView();
		}
	} else if (event.target.matches(".js-tab-header")) {
		//change tab

		var tabs = event.target.parentNode.parentNode.parentNode.querySelectorAll(".js-tab");

		tabs.forEach(function (tab) {
			if (tab.getAttribute("data-tab") == event.target.getAttribute("data-tab")) {
				tab.classList.add("active");
			} else {
				tab.classList.remove("active");
			}
		});
		var headers = event.target.parentNode.parentNode.parentNode.querySelectorAll(".js-tab-header");
		headers.forEach(function (tab) {
			if (tab.getAttribute("data-tab") == event.target.getAttribute("data-tab")) {
				tab.classList.add("active");
			} else {
				tab.classList.remove("active");
			}
		});
	} else if (event.target.matches(".tab-name")) {
		//change tab
		event.target.classList.toggle("open");
		var tab = event.target.parentNode.querySelector(".tab-content");
		if (tab) {
			if (tab.classList.contains("tab-open")) {
				vSlideUp(tab);
				tab.classList.remove("tab-open");
			} else {
				vSlideDown(tab);
				tab.classList.add("tab-open");
			}
		}
		
	}
});

//TAB CODE
/** Tabs **/
var ptabs = document.querySelectorAll(".tabs");

ptabs.forEach(function (tab) {
	var tabs = tab.querySelectorAll(".js-tab");
	//Create Tab Nav
	var tabHeader = document.createElement("div");
	tabHeader.classList.add("tabs-nav");
	var cnt = document.createElement("div");
	cnt.classList.add("content");
	tabs.forEach(function (tab) {
		var rand = Math.floor(Math.random() * 10000000000000);
		var btn = document.createElement("button");
		btn.classList.add("js-tab-header");
		btn.setAttribute("data-tab", rand);
		tab.setAttribute("data-tab", rand);
		btn.innerHTML = tab.querySelector(".tab-name").innerHTML;
		tab.querySelector(".tab-name").style.display = "none";
		cnt.appendChild(btn);
	});
	tabHeader.appendChild(cnt);

	if (tabs.length > 0) {
		tabs[0].parentNode.insertBefore(tabHeader, tabs[0]);
	}

	//Set first as active
	var tabBtns = tab.querySelectorAll(".js-tab-header");
	if (tabBtns.length > 0 && !tabs[0].classList.contains("no-auto-open")) {
		tabBtns[0].classList.add("active");
		tabs[0].classList.add("active");
	}
});

//Allow setting of tab via location hash
// if (window.location.hash) {
// 	var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character

// 	tabBtns.forEach(function (topic) {
// 		if (
// 			topic.innerText.toLowerCase().replace(/[^a-zA-Z0-9]+/g, "") ==
// 			hash.toLowerCase().replace(/[^a-zA-Z0-9]+/g, "")
// 		) {
// 			topic.click();
// 		}
// 	});
// }

//Populate Jumplink Nav Bar

const productJumpNav = document.querySelector(".js-jump-nav");
const jumpLinksArray = document.querySelectorAll("[data-jump-name]");

if (jumpLinksArray.length > 0 && productJumpNav) {
	const contentList = productJumpNav.querySelector(".jumplink-content ul");

	jumpLinksArray.forEach((el) => {
		const newEl = document.createElement("li");

		if (el.classList.contains("location")) {
			newEl.innerHTML = `<a class="location-link" href="${el.dataset.url}">${el.dataset.jumplnkText}</a>`;
		} else {
			newEl.innerHTML = `<button class="js-jump-lnk" data-jump-lnk="${el.dataset.jumplnkname.replace(
				/_/g,
				" "
			)}">${el.dataset.jumplnkText}</button>`;
		}

		contentList.appendChild(newEl);
	});
} else if (productJumpNav) {
	productJumpNav.parentElement.classList.add("empty-set");
}

document.addEventListener("DOMContentLoaded", () => {
	mobileButtonDisplay(1);
});

function mobileButtonDisplay(activeColumn) {
	const compareTable = document.querySelector(".mod-compare-table");

	if (compareTable) {
		const buttonToMove = compareTable.querySelector(
			`.mod-compare-table > table > tbody > tr:last-of-type td:nth-child(${Number(activeColumn) + 1})`
		);
		if (buttonToMove.innerHTML.includes("</a>")) {
			const MBD = compareTable.querySelector(".mobileButtonDisplay");
			MBD.innerHTML = buttonToMove.innerHTML;
		} else {
			const MBD = compareTable.querySelector(".mobileButtonDisplay");
			MBD.innerHTML = "";
		}
	}
}

/******* COUNTER ON SCROLL **********/
// How long you want the animation to take, in ms
const animationDuration = 1000;
// Calculate how long each ‘frame’ should last if we want to update the animation 60 times per second
const frameDuration = 1000 / 60;
// Use that to calculate how many frames we need to complete the animation
const totalFrames = Math.round(animationDuration / frameDuration);
// An ease-out function that slows the count as it progresses
const easeOutQuad = (t) => t * (2 - t);

// The animation function, which takes an Element
const animateCountUp = (el) => {
	let frame = 0;
	let money = "";
	if (el.innerHTML.indexOf("$") != -1) {
		money = "$";
	}
	const countTo = parseInt(el.innerHTML.replace(/\D/g, ""), 10);
	// Start the animation running 60 times per second
	const counter = setInterval(() => {
		frame++;
		// Calculate our progress as a value between 0 and 1
		// Pass that value to our easing function to get our
		// progress on a curve
		const progress = easeOutQuad(frame / totalFrames);
		// Use the progress value to calculate the current count
		const currentCount = Math.round(countTo * progress);

		// If the current count has changed, update the element
		if (parseInt(el.innerHTML.replace(",", ""), 10) !== currentCount) {
			el.innerHTML = money + currentCount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		}

		// If we’ve reached our last frame, stop the animation
		if (frame === totalFrames) {
			clearInterval(counter);
		}
	}, frameDuration);
};

const connectBlocks = document.querySelectorAll(".block-internal-connect");
if(connectBlocks) {
	connectBlocks.forEach((block) => {
		let formSection = block.querySelector(".js-form-section");
		let formOpenButtons = block.querySelectorAll(".js-connect-form-open");
		let formCloseButtons = block.querySelectorAll(".js-connect-form-close");
		formOpenButtons.forEach((button) => {
			button.addEventListener("click", function(event) {
				formSection.classList.add("form-shown");
				setTimeout(() => {
					formSection.classList.add("form-open");
				}, 100);
			});
		});
		formCloseButtons.forEach((button) => {
			button.addEventListener("click", function(event) {
				formSection.classList.remove("form-shown");
				setTimeout(() => {
					formSection.classList.remove("form-open");
				}, 100);
			});
		});
	});
}

const featurePromoDropdown = document.querySelector(".js-feature-promo-dropdown");
if(featurePromoDropdown) {
	document.addEventListener("click", function (event) {
		if(!featurePromoDropdown.contains(event.target) && featurePromoDropdown.classList.contains("active")) {
			let promoDropdownButton = featurePromoDropdown.querySelector(".js-accordion-button");
			let clickEvent = new Event('click', { bubbles: true, cancelable: false });
			promoDropdownButton.dispatchEvent(clickEvent);
		}
	});
}